/*
  Add here your own custom javascript codes
*/

/*
  FIX (2026-06-09): Stop legacy in-description '.btn-atc' handler from hijacking
  the main Add to Cart button (#xp-btn-atc).

  Older-generated PDP descriptions contain a global
  document.querySelectorAll('.btn-atc') click handler intended for the
  Frequently-Bought-Together cross-sell buttons (which carry data-variant).
  Because the main ATC button also has the 'btn-atc' class but NO data-variant,
  that handler read NaN, disabled the button (cancelling the real form submit),
  and re-rendered the offcanvas cart -> drawer opened with an EMPTY cart.

  A capture-phase listener runs BEFORE the legacy bubble-phase handler and
  stops it firing. We do NOT preventDefault, so the genuine submit proceeds via
  the theme's <product-form> -> cart-container.add(). FBT cross-sell buttons and
  the sticky ATC button are untouched.
*/
(function () {
  function guardMainAtc() {
    var main = document.getElementById('xp-btn-atc');
    if (!main || main.dataset.atcGuarded) return;
    main.dataset.atcGuarded = '1';
    main.addEventListener('click', function (e) {
      e.stopImmediatePropagation();
    }, true); // capture phase
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', guardMainAtc);
  } else {
    guardMainAtc();
  }
})();

/*
  WhatsApp button (.wa-float):
  - Repositioned to vertically centered on the right edge (not bottom corner)
  - Hidden when cart drawer is open so it never overlaps checkout
  custom.js is defer-loaded so this never blocks LCP.
*/
(function () {
  var style = document.createElement('style');
  style.textContent = [
    '.wa-float {',
    '  bottom: auto !important;',
    '  top: 50% !important;',
    '  transform: translateY(-50%) !important;',
    '  right: 0 !important;',
    '}',
    'body.er-cart-open .wa-float {',
    '  display: none !important;',
    '}'
  ].join('\n');
  document.head.appendChild(style);

  function initWhatsAppHide() {
    var cart = document.getElementById('offcanvas-cart');
    if (!cart) return;

    new MutationObserver(function () {
      document.body.classList.toggle('er-cart-open', cart.classList.contains('show'));
    }).observe(cart, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhatsAppHide);
  } else {
    initWhatsAppHide();
  }
})();
